module.exports = __webpack_public_path__ + "media/video-poster/720p-89d57b06.jpg";